import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.brandPrimary,
  },
}));

const ConfirmationDialog = ({
  confirmButtonText,
  declineButtonText,
  message,
  onCancel,
  onConfirm,
  title,
  useCustomTitle,
  useCustomMessage,
  visible,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      maxWidth="xs"
      open={visible}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" disableTypography={useCustomTitle}>
        {useCustomTitle ? (
          title
        ) : (
          <Typography classes={{ root: classes.title }}>{title}</Typography>
        )}
      </DialogTitle>
      <DialogContent>
        {useCustomMessage ? (
          message
        ) : (
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} style={{ fontWeight: 400 }} autoFocus>
          {declineButtonText || "Cancel"}
        </Button>
        <Button
          onClick={onConfirm}
          style={{ width: "auto" }}
          color="primary"
          variant="contained"
        >
          {confirmButtonText || "Discard"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
